import React, { useEffect } from "react";
import Header from "@/components/sections/Header";
import Hero from "@/components/sections/Hero";
import Banner from "@/components/sections/Banner";
import Services from "@/components/sections/Services";
import WhyChooseUs from "@/components/sections/WhyChooseUs";
import About from "@/components/sections/About";
import Reviews from "@/components/sections/Reviews";
import LocalSeo from "@/components/sections/LocalSeo";
import Faq from "@/components/sections/Faq";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";
import StickyCall from "@/components/sections/StickyCall";
import CouponPopup from "@/components/CouponPopup";
import SchemaMarkup from "@/components/SchemaMarkup";

export default function Home() {
  useEffect(() => {
    document.title =
      "Veteran's Auto Repair Center | Honest Auto Repair in Madison Heights, MI";
  }, []);

  return (
    <div data-testid="home-page" className="min-h-screen bg-white text-[#1A202C]">
      <SchemaMarkup />
      <Header />
      <main>
        <Hero />
        <Banner />
        <Services />
        <WhyChooseUs />
        <About />
        <Reviews />
        <LocalSeo />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <StickyCall />
      <CouponPopup />
    </div>
  );
}
